import { render, staticRenderFns } from "./OrderTeamCard.vue?vue&type=template&id=3a521404&"
import script from "./OrderTeamCard.vue?vue&type=script&lang=js&"
export * from "./OrderTeamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports